import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ng-ema-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [CommonModule]
})
export class PageNotFoundComponent {}
